import React, { useEffect, useState } from "react";
import { HashLink as Link } from "react-router-hash-link";
import SocialShare from "../others/SocialShare";
import { Box } from "@mui/material";
import { useAuth } from "../../common/AuthContext";

const FooterV1 = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const { isLoggedIn } = useAuth();

  // newsletter modal state
  const [isNewsletterOpen, setIsNewsletterOpen] = useState(false);
  const [newsletterEmail, setNewsletterEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false); // loading state

  const openNewsletter = () => {
    setIsNewsletterOpen(true);
  };

  const closeNewsletter = () => {
    setIsNewsletterOpen(false);
    setNewsletterEmail("");
    setIsSubmitting(false);
  };

  const handleSubscribe = async (e) => {
    e.preventDefault();

    if (!newsletterEmail) {
      alert("Please enter your email.");
      return;
    }

    try {
      setIsSubmitting(true); // button -> Submitting...

      const res = await fetch(
        "https://eventscons.com/eventbackendnew/api/newsletter/subscribe",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: newsletterEmail, // yahan backend jo key expect kare
          }),
        }
      );

      if (!res.ok) {
        const errData = await res.json().catch(() => ({}));
        console.error("Newsletter error:", errData);
        alert(errData?.message || "Subscription failed, please try again.");
        return;
      }

      const data = await res.json();
      console.log("Newsletter response:", data);
      alert(data?.message || "Subscribed successfully!");
      closeNewsletter();
    } catch (error) {
      console.error("Newsletter request failed:", error);
      alert("Something went wrong, please try again.");
    } finally {
      setIsSubmitting(false); // reset loading state
    }
  };

  return (
    <>
      {/* Newsletter Section (footer ke just upar) */}
      <section
        style={{
          backgroundColor: "#000",
          color: "#fff",
          padding: "30px 0",
          borderBottom: "1px solid #ffffff30",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "20px",
            padding: "0 15px",
            flexWrap: "wrap",
          }}
        >
          {/* Left - Heading */}
          <div style={{ flex: "1 1 150px" }}>
            <h2
              style={{
                margin: 0,
                fontSize: "28px",
                letterSpacing: "2px",
                fontWeight: 700,
                color: "#fff",
                textAlign: "left",
              }}
            >
              NEWSLETTER
            </h2>
          </div>

          {/* Center - Text */}
          <div style={{ flex: "2 1 350px" }}>
            <p
              style={{
                margin: 0,
                fontSize: "16px",
                lineHeight: 1.5,
                color: "#ddd",
              }}
            >
              Receive our newsletter and discover our stories, collections and
              surprises.
            </p>
          </div>

          {/* Right - Button */}
          <div
            style={{
              flex: "0 0 auto",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <button
              type="button"
              style={{
                backgroundColor: "#9B1321",
                color: "#fff",
                border: "none",
                padding: "12px 40px",
                textTransform: "lowercase",
                fontSize: "16px",
                fontWeight: 600,
                borderRadius: "10px",
                cursor: "pointer",
              }}
              onClick={openNewsletter}
            >
              subscribe
            </button>
          </div>
        </div>
      </section>

      {/* Newsletter Modal */}
      {isNewsletterOpen && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "12px",
              maxWidth: "520px",
              width: "100%",
              padding: "30px 30px 24px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
            }}
          >
            <h2
              style={{
                margin: "0 0 20px",
                fontSize: "28px",
                fontWeight: 500,
              }}
            >
              Subscribe to Our Newsletter
            </h2>

            <form onSubmit={handleSubscribe}>
              {/* Email input */}
              <div style={{ marginBottom: "20px" }}>
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={newsletterEmail}
                  onChange={(e) => setNewsletterEmail(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "12px 14px",
                    fontSize: "16px",
                    borderRadius: "6px",
                    border: "1px solid #ddd",
                    outline: "none",
                  }}
                  required
                />
              </div>

              {/* Buttons */}
              <div
                style={{
                  display: "flex",
                  gap: "12px",
                }}
              >
                <button
                  type="submit"
                  disabled={isSubmitting}
                  style={{
                    backgroundColor: "#9B1321",
                    color: "#fff",
                    border: "none",
                    padding: "10px 28px",
                    fontSize: "16px",
                    borderRadius: "6px",
                    cursor: isSubmitting ? "not-allowed" : "pointer",
                    opacity: isSubmitting ? 0.8 : 1,
                  }}
                >
                  {isSubmitting ? "Submitting..." : "Subscribe"}
                </button>
                <button
                  type="button"
                  onClick={closeNewsletter}
                  disabled={isSubmitting}
                  style={{
                    backgroundColor: "#5A6268",
                    color: "#fff",
                    border: "none",
                    padding: "10px 28px",
                    fontSize: "16px",
                    borderRadius: "6px",
                    cursor: isSubmitting ? "not-allowed" : "pointer",
                    opacity: isSubmitting ? 0.8 : 1,
                  }}
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Existing Footer */}
      <footer className="main-footer">
        <div className="widgets-section">
          <div className="auto-container">
            <div className="row">
              <div className="big-column col-xl-6 col-lg-12 col-md-12 col-sm-12">
                <div className="row">
                  <div className="footer-column col-xl-7 col-lg-6 col-md-6 col-sm-12">
                    <div className="footer-widget about-widget">
                      <div className="logo">
                        <Link to="/#">
                          <img src="/images/logo-2.png" alt="image" />
                        </Link>
                      </div>
                      <div className="text">
                        <p>
                          Empowering Success Through Exceptional Events – We are
                          Your Trusted Partner in Conference and Exhibition
                          Management.
                        </p>
                      </div>
                      <ul className="social-icon-one social-icon-colored">
                        <SocialShare />
                      </ul>
                    </div>
                  </div>
                  <div className="footer-column col-xl-5 col-lg-6 col-md-6 col-sm-12">
                    <div className="footer-widget widget-ps-50">
                      <h2 className="widget-title">Useful Links</h2>
                      <ul className="user-links">
                        <li>
                          <Link to="/home">Home </Link>
                        </li>
                        <li>
                          <Link to="/conferences">Conferences </Link>
                        </li>
                        <li>
                          <Link to="/page/exhibitions">Exhibition </Link>
                        </li>
                        <li>
                          <Link to="/about-us#">Our Story</Link>
                        </li>
                        <li>
                          <Link to="/our_team">Our Team</Link>
                        </li>
                        <li>
                          <Link to="/our_clients">Our Clients</Link>
                        </li>
                        <li>
                          <Link to="/gallery">Gallery</Link>
                        </li>
                        <li>
                          <Link to="/job/list">Careers</Link>
                        </li>
                        {isLoggedIn && (
                          <li>
                            <Link to="/faq">FAQs</Link>
                          </li>
                        )}
                        {!isLoggedIn && (
                          <li>
                            <Link to="/login">FAQs</Link>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="big-column col-xl-6 col-lg-12 col-md-12 col-sm-12">
                <div className="row">
                  <div className="footer-column col-xl-5 col-lg-6 col-md-6 col-sm-12">
                    <div className="footer-widget widget-ps-50">
                      <h2 className="widget-title">Events</h2>
                      <ul className="user-links">
                        <li>
                          <Link to="/up/event">Up Coming Events </Link>
                        </li>
                        <li>
                          <Link to="/pre/con">Previous Events </Link>
                        </li>
                      </ul>
                    </div>
                    <div className="footer-widget widget-ps-50">
                      <h2 className="widget-title">Travel </h2>
                      <ul className="user-links">
                        <li>
                          <Link to="/tour_slider">Sights </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="footer-column col-lg-6 col-md-6 col-sm-12">
                    <div className="footer-widget contact-widget">
                      <h2 className="widget-title">Contact Us</h2>
                      <div className="widget-content">
                        <ul className="contact-list">
                          <li>
                            <span className="icon flaticon-clock"></span>
                            <div className="text">
                              Mon - Fri: 09:00 - 18:00
                            </div>
                          </li>
                          <li>
                            <span className="icon flaticon-phone"></span>
                            <div className="text">
                              <Link to="tel:+962799602002">
                                +962 79 960 2002
                              </Link>
                            </div>
                          </li>
                          <li>
                            <span className="icon flaticon-paper-plane"></span>
                            <div className="text">
                              <Link to="mailto:info@eventscons.com">
                                info@eventscons.com
                              </Link>
                            </div>
                          </li>
                          <li>
                            <span className="icon flaticon-worldwide"></span>
                            <div className="text">
                              Rawhi Al Qutabi Commercial Complex, Al Swaifieh Al
                              Wakalat St, 7, Amman, Jordan
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <Box
                      sx={{
                        marginTop: "1rem",
                        borderRadius: "8px",
                        boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                        width: "100%",
                        margin: "auto",
                      }}
                    >
                      <iframe
                        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d54162.63123254484!2d35.86073700000001!3d31.956435!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151ca10ff839a7bf%3A0xa854064ff6e1a48b!2zRXZlbnRzIENvbnN1bHRhbnQgY29tcGFueSAtINi02LHZg9ipINin2YTZhdiz2KrYtNin2LEg2YTZhNmF2KTYqtmF2LHYp9iq!5e0!3m2!1sen!2sus!4v1728902606826!5m2!1sen!2sus"
                        width="100%"
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        style={{ border: "0", borderRadius: "8px" }}
                      ></iframe>
                    </Box>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="auto-container">
            <div className="inner-container clearfix">
              <div className="copyright-text">
                <p>
                  &copy; Copyright {new Date().getFullYear()} All Rights
                  Reserved by{" "}
                  <Link to="" target="_blank">
                    Event Consultant.
                  </Link>
                </p>
              </div>
              <p>
                {" "}
                Designed and Developed by{" "}
                <Link to="https://mayazin.net/" target="_blank">
                  {" "}
                  MAYAZIN
                </Link>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default FooterV1;
